/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConversationalAgentProtocolEnum } from './ConversationalAgentProtocolEnum';
import {
  ConversationalAgentProtocolEnumFromJSON,
  ConversationalAgentProtocolEnumFromJSONTyped,
  ConversationalAgentProtocolEnumToJSON,
} from './ConversationalAgentProtocolEnum';

/**
 *
 * @export
 * @interface ConversationalAgentInferencerCelinaCreate
 */
export interface ConversationalAgentInferencerCelinaCreate {
  /**
   *
   * @type {string}
   * @memberof ConversationalAgentInferencerCelinaCreate
   */
  name: string;
  /**
   *
   * @type {ConversationalAgentProtocolEnum}
   * @memberof ConversationalAgentInferencerCelinaCreate
   */
  protocol: ConversationalAgentProtocolEnum;
  /**
   *
   * @type {Date}
   * @memberof ConversationalAgentInferencerCelinaCreate
   */
  timestamp?: Date;
  /**
   *
   * @type {string}
   * @memberof ConversationalAgentInferencerCelinaCreate
   */
  environment: string;
  /**
   *
   * @type {string}
   * @memberof ConversationalAgentInferencerCelinaCreate
   */
  tenant: string;
  /**
   *
   * @type {string}
   * @memberof ConversationalAgentInferencerCelinaCreate
   */
  region?: string;
  /**
   *
   * @type {string}
   * @memberof ConversationalAgentInferencerCelinaCreate
   */
  domain?: string;
  /**
   *
   * @type {number}
   * @memberof ConversationalAgentInferencerCelinaCreate
   */
  credentialId?: number | null;
}

/**
 * Check if a given object implements the ConversationalAgentInferencerCelinaCreate interface.
 */
export function instanceOfConversationalAgentInferencerCelinaCreate(
  value: object,
): value is ConversationalAgentInferencerCelinaCreate {
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('protocol' in value) || value['protocol'] === undefined) return false;
  if (!('environment' in value) || value['environment'] === undefined) return false;
  if (!('tenant' in value) || value['tenant'] === undefined) return false;
  return true;
}

export function ConversationalAgentInferencerCelinaCreateFromJSON(
  json: any,
): ConversationalAgentInferencerCelinaCreate {
  return ConversationalAgentInferencerCelinaCreateFromJSONTyped(json, false);
}

export function ConversationalAgentInferencerCelinaCreateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ConversationalAgentInferencerCelinaCreate {
  if (json == null) {
    return json;
  }
  return {
    name: json['name'],
    protocol: ConversationalAgentProtocolEnumFromJSON(json['protocol']),
    timestamp: json['timestamp'] == null ? undefined : new Date(json['timestamp']),
    environment: json['environment'],
    tenant: json['tenant'],
    region: json['region'] == null ? undefined : json['region'],
    domain: json['domain'] == null ? undefined : json['domain'],
    credentialId: json['credential_id'] == null ? undefined : json['credential_id'],
  };
}

export function ConversationalAgentInferencerCelinaCreateToJSON(
  value?: ConversationalAgentInferencerCelinaCreate | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    name: value['name'],
    protocol: ConversationalAgentProtocolEnumToJSON(value['protocol']),
    timestamp: value['timestamp'] == null ? undefined : value['timestamp'].toISOString(),
    environment: value['environment'],
    tenant: value['tenant'],
    region: value['region'],
    domain: value['domain'],
    credential_id: value['credentialId'],
  };
}
